import ConversationConfig from './ConversationConfig';

export default ConversationConfig;
